"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M1 2.751h14a1 1 0 0 1 1 1v8.498a.992.992 0 0 1-.906.981l-.019.016-.009-.011c-.01 0-.02.004-.03.007a.12.12 0 0 1-.036.007H1a.126.126 0 0 1-.037-.007.145.145 0 0 0-.03-.007l-.007.009-.017-.014A.99.99 0 0 1 0 12.249V3.751a1 1 0 0 1 1-1Zm13.093 1L8 8.871l-6.094-5.12h12.187ZM1.744 12.249 4.998 8.29l-.773-.635L1 11.58V4.295l7 5.882 7-5.882v7.29l-3.251-3.93-.771.638 3.272 3.956H1.744Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M.75 3.75h22.5a.75.75 0 0 1 .75.75v14.247a.75.75 0 0 1-.75.75H.75a.75.75 0 0 1-.75-.75V4.5a.75.75 0 0 1 .75-.75Zm1.372 1.125h19.756L12 13.175l-9.878-8.3Zm15.358 6.352-.867.717 5.316 6.428H2.065l5.288-6.433-.87-.714-5.358 6.519V5.507L12 14.644l10.875-9.138V17.75l-5.395-6.523Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M1 5h30a1 1 0 0 1 1 1v18.996a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1Zm1.829 1.5H29.17L16 17.566 2.829 6.5Zm20.477 8.469-1.156.956 7.089 8.571H2.753l7.051-8.577-1.16-.952L1.5 23.658V7.343L16 19.525 30.5 7.342v16.324l-7.194-8.697Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M.75 8.25h46.5A.75.75 0 0 1 48 9v29.993a.75.75 0 0 1-.75.75H.75a.75.75 0 0 1-.75-.75V9a.75.75 0 0 1 .75-.75Zm2.756 1.875h40.989L24 27.343 3.506 10.125Zm31.309 13.197-1.445 1.195 11.043 13.351H3.58L14.56 24.51l-1.448-1.191-11.238 13.67V11.204L24 29.792l22.126-18.59v25.794L34.815 23.322Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M1 11h62.001a1 1 0 0 1 1 1v39.991a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V12a1 1 0 0 1 1-1Zm3.675 2.5h54.65L32 36.458 4.675 13.5ZM46.42 31.096l-1.927 1.593 14.724 17.802H4.774L19.415 32.68l-1.931-1.588L2.5 49.319V14.938L32 39.724l29.501-24.786v34.391L46.42 31.096Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconEmail = function IconEmail(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Email' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "Email"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconEmail.sizes = [16, 24, 32, 48, 64];
IconEmail.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconEmail;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lmig/design-system-icons-react/_cjs/account-experience/Email.js
// module id = 1749
// module chunks = 0